export default function DisasterIslandIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="10" fill="#5DB8F5" />
      <path d="M0 46h64v18H0Z" fill="#2F8FD8" />
      <path d="M6 48c4-3 8-3 12 0s8 3 12 0 8-3 12 0 8 3 12 0 6-2 10 0" stroke="#BFE8FF" strokeWidth="2" fill="none" />
      <path d="M8 46l6-6h36l6 6Z" fill="#F2D59A" />
      <rect x="14" y="26" width="14" height="14" fill="#F2A65A" />
      <rect x="14" y="23" width="14" height="4" fill="#D9534F" />
      <rect x="19" y="32" width="4" height="8" fill="#7A4A2A" />
      <rect x="32" y="16" width="10" height="24" fill="#9BB1C8" />
      <rect x="32" y="13" width="10" height="4" fill="#3A506B" />
      <rect x="34" y="20" width="2.5" height="3" fill="#E0FBFC" />
      <rect x="37.5" y="20" width="2.5" height="3" fill="#E0FBFC" />
      <rect x="34" y="27" width="2.5" height="3" fill="#E0FBFC" />
      <rect x="37.5" y="27" width="2.5" height="3" fill="#E0FBFC" />
      <path d="M44 6h14l-3 5h-8l2 5h-5l1 5h-3l-1 6-2-6h-1l1-5h-2l1-5h-1Z" fill="#E6EAF0" opacity="0.95" />
      <circle cx="12" cy="10" r="4" fill="#FF8C42" />
      <path d="M15 13l7 7" stroke="#FFD166" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}
